import React, { useState } from "react";
import { IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useHistory } from "react-router-dom";

const calcularCambio = (venta, proyeccion) => {
    const diferencia = proyeccion - venta;
    const porcentaje = ((diferencia / proyeccion) * 100).toFixed(2);
    let direccion = "";

    if (porcentaje <= 20) {
        direccion = "arriba";
    } else if (porcentaje > 20 && porcentaje <= 40) {
        direccion = "igual";
    } else {
        direccion = "abajo";
    }

    return { porcentaje, direccion };
};

export const DashboardCobranzaHeader = ({ data, dataConveniado, sucursales }) => {
    const history = useHistory();
    const formatmiles = (number) => Math.floor((number ?? 0) / 1000).toLocaleString("en-US");

    const porVencer = dataConveniado?.find((item) => item.estado === "P");
    const vencido = dataConveniado?.find((item) => item.estado === "V");

    const importeConveniado = (porVencer?.conveniado ?? 0) + (vencido?.conveniado ?? 0);
    const clientesConveniado = (porVencer?.clientes_conveniados ?? 0) + (vencido?.clientes_conveniados ?? 0);
    const porcConveniado = (importeConveniado / data[0].importe_objetivo) * 100;

    // console.log(importeConveniado)

    const { porcentaje: porcentajeUtilidad, direccion: direccionUtilidad } = calcularCambio(data[0].importe_recuperado, data[0].importe_objetivo);
    // console.log(data)
    const encabezados = [
        { title: "Total", cantidad: data[0].importe_total, porcentaje: 100, clientes: data[0].clientes_total },
        { title: "Objetivo", cantidad: data[0].importe_objetivo, porcentaje: 100, clientes: data[0].clientes_objetivo },
        { title: "Recuperado", cantidad: data[0].importe_recuperado, porcentaje: data[0].porc_importe_recuperado, clientes: data[0].clientes_recuperados },
        { title: "Por recuperar", cantidad: data[0].importe_porRecuperar, porcentaje: data[0].porc_porRecuperar, clientes: data[0].clientes_porRecuperar },
        { title: "Conveniado", cantidad: importeConveniado, porcentaje: porcConveniado.toFixed(2), clientes: clientesConveniado },
        { title: "Jurídico", cantidad: 10000, porcentaje: 34.5, clientes: 119 },
    ];

    // Estado para manejar el índice del grupo actual
    const [grupoActivo, setGrupoActivo] = useState(0);

    // Dividir los encabezados en grupos de 3
    const grupos = [
        encabezados.slice(0, 3), // Primer grupo de 3
        encabezados.slice(3, 6), // Segundo grupo de 3
    ];

    // Función para avanzar al siguiente grupo
    const handleNextGroup = () => {
        setGrupoActivo((prev) => (prev + 1) % grupos.length);
    };

    // Función para retroceder al grupo anterior
    const handlePrevGroup = () => {
        setGrupoActivo((prev) => (prev - 1 + grupos.length) % grupos.length);
    };

    return (
        <div className="dashboard-cobranza-header">
            <div className="dashboard-cobranza-header-container">
                <IconButton onClick={handlePrevGroup}>
                    <ArrowBackIosIcon />
                </IconButton>

                {/* Renderizar encabezados del grupo activo */}
                <div className="dashboard-cobranza-header-group">
                    {grupos[grupoActivo].map((item, index) => (
                        <div
                            key={index}
                            className="dashboard-cobranza-header-item"
                            onClick={() => {
                                if (item.title === "Conveniado") {
                                    history.push("/Creditoycobranza/GestionClientes", {
                                        permisos: sucursales,
                                        filtro: "V",
                                    });
                                }
                            }}
                        >
                            <div className="dashboard-cobranza-header-title">{item.title}</div>
                            <div className="dashboard-cobranza-header-cantidad">
                                $ {formatmiles(item.cantidad)} | {item.porcentaje}%
                            </div>
                            <div className="dashboard-cobranza-header-footer">
                                {item.title === 'Recuperado' && (
                                    <div className={`change-indicator ${direccionUtilidad}`}>
                                        {/* {direccionUtilidad === "arriba" && <KeyboardArrowUpIcon />}
                                    {direccionUtilidad === "abajo" && <KeyboardArrowDownIcon />}
                                    {direccionUtilidad === "igual" && <HorizontalRuleIcon />} */}
                                    </div>
                                )}
                                Total de clientes: {item.clientes}
                            </div>
                        </div>
                    ))}
                </div>

                <IconButton onClick={handleNextGroup}>
                    <ArrowForwardIosIcon />
                </IconButton>
            </div>
        </div>
    );
};